module.exports = "<md-slider mdTooltip=\"{{ 'VOLUME' | tooltip }} {{volume}}\" mdTooltipPosition=\"above\" min=\"0\" max=\"100\" step=\"10\"  [(ngModel)]=\"volume\" (change)=\"onChange()\"></md-slider>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/music-volume/music-volume.component.html
// module id = ./src/app/player/music-volume/music-volume.component.html
// module chunks = main